import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Button,
  HStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

const ExploreSection = () => {
  const navigate = useNavigate();
  const headingColor = useColorModeValue("white", "white");

  const handlePartnershipClick = () => {
    // Navigate to contact page with partnership form parameter
    navigate('/contact?form=partnership');
  };

  const handleContactClick = () => {
    navigate('/contact?form=product');
  };

  return (
    <Box>
      {/* Explore Hero Section */}
      <Box
        maxW="6xl"
        mx="auto"
        bgImage="url('/png/share-your-idea.png')"
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="cover"
        py={16}
        px={6}
        textAlign="center"
        position="relative"
        overflow="hidden"
        borderRadius="lg"
        my={8}
        _before={{
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bg: "blackAlpha.400", // Optional overlay for better text readability
          borderRadius: "lg",
        }}
      >
        <Container maxW="7xl" position="relative" zIndex={1}>
          <Heading
            size="xl"
            color={headingColor}
            fontWeight="bold"
            mb={6}
          >
            Let's Explore Opportunities Together
          </Heading>

          <Text
            fontSize={{ base: "sm", md: "md" }}
            color="gray.100"
            lineHeight="tall"
            mb={8}
            maxW="5xl"
            mx="auto"
          >
            If you are working on a donor-funded opportunity, government automation project, or digital inclusion program and need a capable, reliable, and innovative Bangladeshi software partner—we'd be honored to support your vision.
          </Text>

          <HStack spacing={4} justify="center" flexWrap="wrap">
            <Button
              size="lg"
              bg="white"
              color="#000B8C"
              _hover={{ bg: "gray.100" }}
              borderRadius="full"
              px={8}
              onClick={handlePartnershipClick}
            >
              Partner With Us
            </Button>
            
            <Button
              size="lg"
              variant="outline"
              borderColor="white"
              color="white"
              _hover={{ 
                bg: "whiteAlpha.200",
                borderColor: "white"
              }}
              borderRadius="full"
              px={8}
              onClick={handleContactClick}
            >
              Contact Us
            </Button>
          </HStack>
        </Container>
      </Box>
    </Box>
  );
};

export default ExploreSection;
